export const NETWORK_ACTIVITY_STARTED = "NETWORK_ACTIVITY_STARTED";
export const NETWORK_ACTIVITY_COMPLETETD = "NETWORK_ACTIVITY_COMPLETETD";
